import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import { faqs } from "@/mocks/forecast";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-4">
            <Reveal>
              <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.28em] text-primary-600">
                <span className="h-px w-6 bg-primary-400" />
                常见问题
              </p>
              <h2 className="mt-3 font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-4xl">
                关于看料大瓜，你可能想问
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                这里整理了最常被问到的几个问题。如果还有疑问，欢迎通过关于页面的联系方式告诉我们。
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-300 border-y border-background-300">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={faq.q}>
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? null : index)}
                        aria-expanded={isOpen}
                        className="flex w-full items-center justify-between gap-4 py-5 text-left"
                      >
                        <span className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                          {faq.q}
                        </span>
                        <span
                          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition-colors ${
                            isOpen
                              ? "border-primary-500 bg-primary-500 text-background-50"
                              : "border-background-300 text-foreground-600"
                          }`}
                        >
                          <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                        </span>
                      </button>
                    </h3>
                    <div className={`overflow-hidden transition-all duration-300 ${isOpen ? "max-h-60" : "max-h-0"}`}>
                      <p className="pb-5 pr-10 text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}